// ** Initial State
const initialState = {
  data: [],
  paginationMeta: {
    page: 1,
    pageSize: 20,
    total: 0,
    totalPages: 0,
  },
  selectedOrder: {},
};

const orders = (state = initialState, action) => {
  switch (action.type) {
  case 'GET_ORDERS_(D)':
    return {
      ...state,
      data: action.data.data,
      paginationMeta: {
        page: action.data.page,
        pageSize: action.data.pageSize,
        total: action.data.total,
        totalPages: action.data.totalPages,
      },
    };

  case 'GET_DRIVER_ORDER_DETAILS':
    return {
      ...state,
      selectedOrder: action.data.data,
    };
  default:
    return { ...state };
  }
};
export default orders;
